// import React, { useRef } from 'react'
// import { Link } from 'react-router-dom';
// import './footer.scss'
// import FooterVideo from '../../Assets/Footer.mp4'
// import { FiChevronRight, FiSend } from 'react-icons/fi'
// // import { MdOutlineTravelExplore } from 'react-icons/md'
// import { AiFillInstagram, AiFillYoutube, AiOutlineTwitter } from 'react-icons/ai'
// import { FaTripadvisor } from 'react-icons/fa'
// import emailjs from '@emailjs/browser'
// import Logo from '../../Assets/Logo.png'

// const Footer = () => {
//     const form = useRef();

//     const sendEmail = (e) => {
//         e.preventDefault();

//         emailjs.sendForm(
//             "service_a0f6obr",   //  EmailJS Service ID
//             "template_0hv31k9",  // EmailJS Template ID
//             form.current,
//             "pLd3QhrFmeSifW3Ka"    //EmailJS Public Key
//         )
//             .then(
//                 (result) => {
//                     alert("Email sent successfully!");
//                 },
//                 (error) => {
//                     alert("Error sending email. Please try again.");
//                 }
//             );
//     }

//     return (
//         <section className="footer">
//             <div className="videoDiv">
//                 <video src={FooterVideo} loop autoPlay muted type="video/mp4"></video>
//             </div>

//             <div className="secContent container">
//                 <div className="contactDiv flex">
//                     <div className="text">
//                         <small>KEEP IN TOUCH</small>
//                         <h2> Travel With Us</h2>
//                     </div>
//                     {/* Email form */}
//                     <form ref={form} onSubmit={sendEmail} className="inputDiv flex">
//                         <input type="email" name="user_email" placeholder='Enter Email Address' required />
//                         <button className='btn flex ' type='submit'>
//                             SEND <FiSend className='icon' />
//                         </button>
//                     </form>
//                 </div>

//                 <div className="footerCard flex">
//                     <div className="footerIntro flex">
//                         <div className="logoDiv">
//                             <a href='' className='logo flex'>
//                                 World Adventures Tours
//                             </a>
//                         </div>
//                         <div className="footerParagraph">
//                             Explore the world with World Adventures Tours. Your gateway to breathtaking destinations, thrilling treks, and unforgettable journeys. Discover new paths and create memories that last a lifetime.
//                         </div>

//                         <div className="footerSocials flex">
//                             <AiOutlineTwitter className='icon' />
//                             <AiFillYoutube className='icon' />
//                             <AiFillInstagram className='icon' />
//                             <FaTripadvisor className='icon' />
//                         </div>
//                     </div>

//                     <div className="footerLinks grid">
//                         {/* first part */}
//                         <div className="linkGroup">
//                             <span className=' groupTitle'>
//                                 Tours
//                             </span>

//                             <li className="footerList" >
//                                 <Link to="/mohenjo-daro-tours" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     MohenjoDaro
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/lahore-heritage-tours" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     Lahore City
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/multan-city-tours" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     Multan City
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/hunza-valley-tours" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     Hunza Valley
//                                 </Link>
//                             </li>

//                             <li className="footerList">
//                                 <Link to="taxila-tours" className="flex">
//                                     <FiChevronRight className="icon" />
//                                     Taxila Tours
//                                 </Link>
//                             </li>
//                         </div>

//                         {/* second part */}
//                         <div className="linkGroup">
//                             <span className=' groupTitle'>
//                                 Expeditions
//                             </span>

//                             <li className="footerList" >
//                                 <Link to="/k2-expedition" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     K2
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/nangaparbat-expedition" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     NangaParbat
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/broad-peak-expedition" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     BroadPeak
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/laila-peak-expedition" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     LailaPeak
//                                 </Link>
//                             </li>

//                             <li className="footerList">
//                                 <Link to="/trango-tower-expedition" className="flex">
//                                     <FiChevronRight className="icon" />
//                                     Trango Tower
//                                 </Link>
//                             </li>
//                         </div>

//                         {/* third part */}
//                         <div className="linkGroup">
//                             <span className=' groupTitle'>
//                                 Treks
//                             </span>

//                             <li className="footerList" >
//                                 <Link to="/k2-base-camp-trek" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     K2 Base Camp
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/biafo-hispar-trek" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     Biafo Hispar Trek
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/fairy-meadows-trek" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     Fairy Meadows
//                                 </Link>
//                             </li>

//                             <li className="footerList flex">
//                                 <Link to="/rush-lake-trek" className="flex">
//                                     <FiChevronRight className='icon' />
//                                     Rush Lake Trek
//                                 </Link>
//                             </li>

//                             <li className="footerList">
//                                 <Link to="/nagma-valley-trek" className="flex">
//                                     <FiChevronRight className="icon" />
//                                     Nagma Valley
//                                 </Link>
//                             </li>
//                         </div>

//                     </div>

//                     <div className="footerDiv flex">
//                         <small>BEST TOUR OPERATOR IN PAKISTAN</small>
//                         <small>
//                             © {new Date().getFullYear()} WorldAdventuresTours.com — All Rights Reserved
//                         </small>
//                     </div>

//                 </div>
//             </div>
//         </section>
//     )
// }

// export default Footer
import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import './footer.scss'
import FooterVideo from '../../Assets/Footer.mp4'
import { FiChevronRight, FiSend, FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi'
import { AiFillInstagram, AiFillYoutube, AiOutlineTwitter, AiFillFacebook } from 'react-icons/ai'
import { FaTripadvisor, FaWhatsapp } from 'react-icons/fa'
import { BiWorld } from 'react-icons/bi'
import emailjs from '@emailjs/browser'
import Logo from '../../Assets/Logo.png'

const Footer = () => {
    const form = useRef();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        emailjs.sendForm(
            "service_a0f6obr",
            "template_0hv31k9",
            form.current,
            "pLd3QhrFmeSifW3Ka"
        )
            .then(() => {
                setIsSubscribed(true);
                setEmail('');
                setTimeout(() => setIsSubscribed(false), 3000);
            })
            .catch((error) => {
                console.error('Email send error:', error);
                alert("Error sending email. Please try again.");
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const quickLinks = [
        { title: 'Home', path: '/' },
        { title: 'About Us', path: '/About' },
        { title: 'Challenging Treks', path: '/category/Challenging-treks' },
        { title: 'Cultural Tours', path: '/category/Cultural-tours' },
        { title: 'Expeditions', path: '/category/8000M Plus Peaks-expeditions' },
        { title: 'Contact', path: '/Contact' },
    ];

    const popularTours = [
        { title: 'Mohenjo Daro Tours', path: '/mohenjo-daro-tours' },
        { title: 'Lahore Heritage Tours', path: '/lahore-heritage-tours' },
        { title: 'Hunza Valley Tours', path: '/hunza-valley-tours' },
        { title: 'Multan City Tours', path: '/multan-city-tours' },
        { title: 'Skardu Valley Tours', path: '/skardu-valley-tours' },
        { title: 'Ghanche Valley Tours', path: '/ghanche-valley-tours' },
    ];

    const expeditions = [
        { title: 'K2 Expedition', path: '/k2-expedition' },
        { title: 'Nanga Parbat Expedition', path: '/nangaparbat-expedition' },
        { title: 'Broad Peak Expedition', path: '/broad-peak-expedition' },
        { title: 'Gasherbrum II Expedition', path: '/gasherbrum-ii-expedition' },
        { title: 'Gasherbrum I Expedition', path: '/gasherbrum-i-expedition' },
        { title: 'Laila Peak Expedition', path: '/laila-peak-expedition' },
        { title: 'Trango Tower Expedition', path: '/trango-tower-expedition' },
    ];

    const treks = [
        { title: 'K2 Base Camp Trek', path: '/k2-base-camp-trek' },
        { title: 'K2 Gandogoro La Trek', path: '/k2-gandogoro-la-trek' },
        { title: 'Biafo Hispar Trek', path: '/biafo-hispar-trek' },
        { title: 'Fairy Meadows Trek', path: '/fairy-meadows-trek' },
        { title: 'Rush Lake Trek', path: '/rush-lake-trek' },
        { title: 'Rakaposhi Base Camp', path: '/rakaposhi-trek' },
    ];

    const contactInfo = [
        { icon: <FiMapPin />, text: 'Skardu, Pakistan' },
        { icon: <FiPhone />, text: '+92 349 158 9717' },
        { icon: <FiMail />, text: 'info@worldadventurestours.com' },
        { icon: <FiClock />, text: 'Mon - Fri: 9:00 AM - 6:00 PM' },
    ];

    const socialLinks = [
        { icon: <AiFillFacebook />, url: 'https://www.facebook.com/WorldAdventurTours', label: 'Facebook' },
        { icon: <AiFillInstagram />, url: 'https://www.instagram.com/worldadventurestours/?hl=en', label: 'Instagram' },
        { icon: <AiOutlineTwitter />, url: 'https://x.com/Mr_awaisqarni', label: 'Twitter' },
        { icon: <FaTripadvisor />, url: 'https://tripadvisor.com/worldadventurestours', label: 'TripAdvisor' },
        { icon: <FaWhatsapp />, url: 'https://wa.me/971555936448', label: 'WhatsApp' },
    ];

    return (
        <footer className="footer">
            {/* Newsletter Section */}
            <div className="newsletter-section">
                <div className="newsletter-container container">
                    <div className="newsletter-content">
                        <div className="newsletter-text">
                            <span className="newsletter-badge">Stay Updated</span>
                            <h2>Subscribe to Our Newsletter</h2>
                            <p>Get exclusive deals, travel tips, and adventure updates directly to your inbox</p>
                        </div>
                        
                        <form ref={form} onSubmit={sendEmail} className="newsletter-form">
                            <div className="input-group">
                                <input 
                                    type="email" 
                                    name="user_email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email address"
                                    required
                                    disabled={isSubmitting}
                                />
                                <button 
                                    type="submit" 
                                    className="subscribe-btn"
                                    disabled={isSubmitting || isSubscribed}
                                >
                                    {isSubmitting ? (
                                        <span className="spinner"></span>
                                    ) : isSubscribed ? (
                                        'Subscribed!'
                                    ) : (
                                        <>
                                            Subscribe <FiSend className="icon" />
                                        </>
                                    )}
                                </button>
                            </div>
                            <p className="newsletter-note">We respect your privacy. Unsubscribe at any time.</p>
                        </form>
                    </div>
                </div>
            </div>

            {/* Main Footer Content */}
            <div className="footer-main">
                <div className="footer-container container">
                    {/* Brand Column */}
                    <div className="footer-column brand-column">
                        <Link to="/" className="footer-brand">
                            <img src={Logo} alt="World Adventures Tours" className="brand-logo" />
                            <div className="brand-text">
                                <h3>World Adventures Tours</h3>
                                <p className="brand-tagline">Explore Beyond Boundaries</p>
                            </div>
                        </Link>
                        
                        <p className="company-description">
                            As Pakistan's premier adventure travel company, we specialize in creating unforgettable 
                            experiences across majestic mountains, ancient civilizations, and breathtaking landscapes.
                        </p>
                        
                        <div className="contact-details">
                            {contactInfo.map((item, index) => (
                                <div key={index} className="contact-item">
                                    {item.icon}
                                    <span>{item.text}</span>
                                </div>
                            ))}
                        </div>

                        <div className="social-links">
                            <span className="social-title">Follow Our Adventures</span>
                            <div className="social-icons">
                                {socialLinks.map((social, index) => (
                                    <a 
                                        key={index}
                                        href={social.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-icon"
                                        aria-label={social.label}
                                    >
                                        {social.icon}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Quick Links Column */}
                    <div className="footer-column">
                        <h4 className="column-title">Quick Links</h4>
                        <ul className="footer-links">
                            {quickLinks.map((link, index) => (
                                <li key={index}>
                                    <Link to={link.path} className="footer-link">
                                        <FiChevronRight className="link-icon" />
                                        {link.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Popular Tours Column */}
                    <div className="footer-column">
                        <h4 className="column-title">Popular Tours</h4>
                        <ul className="footer-links">
                            {popularTours.map((tour, index) => (
                                <li key={index}>
                                    <Link to={tour.path} className="footer-link">
                                        <FiChevronRight className="link-icon" />
                                        {tour.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Adventure Columns */}
                    <div className="footer-column-group">
                        <div className="footer-column">
                            <h4 className="column-title">Expeditions</h4>
                            <ul className="footer-links">
                                {expeditions.map((expedition, index) => (
                                    <li key={index}>
                                        <Link to={expedition.path} className="footer-link">
                                            <FiChevronRight className="link-icon" />
                                            {expedition.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="footer-column">
                            <h4 className="column-title">Treks</h4>
                            <ul className="footer-links">
                                {treks.map((trek, index) => (
                                    <li key={index}>
                                        <Link to={trek.path} className="footer-link">
                                            <FiChevronRight className="link-icon" />
                                            {trek.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="bottom-container container">
                    <div className="copyright">
                        <p>
                            © {new Date().getFullYear()} World Adventures Tours. All Rights Reserved.
                            <span className="separator">|</span>
                            <Link to="/privacy-policy" className="policy-link">Privacy Policy</Link>
                            <span className="separator">|</span>
                            <Link to="/terms-conditions" className="policy-link">Terms & Conditions</Link>
                        </p>
                    </div>
                    
                    <div className="certifications">
                        <div className="certification-item">
                            <BiWorld className="cert-icon" />
                            <span>Licensed Tour Operator</span>
                        </div>
                        <div className="certification-item">
                            <FaWhatsapp className="cert-icon" />
                            <span>24/7 Support Available</span>
                        </div>
                    </div>
                    
                    <div className="payment-methods">
                        <span className="payment-text">Secure Payments:</span>
                        <div className="payment-icons">
                            <span className="payment-icon visa">Visa</span>
                            <span className="payment-icon mastercard">MasterCard</span>
                            <span className="payment-icon paypal">PayPal</span>
                            <span className="payment-icon stripe">Stripe</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer